import localesEs from 'Jsx/MainFooter/locales/es';
import getStaticUrl from 'Jsx/Utils/getStaticUrl';

export const itemsWithPrefix = (items, prefix, siteUrl) =>
  items.map(c => ({
    ...c,
    link: `${
      prefix && !c.noCountryPrefix ? `${siteUrl}/${prefix}` : `${siteUrl}`
    }${c.link}`,
  }));

export const getPaymentMethod = prefix => {
  switch (prefix) {
    case 'pe':
      return getStaticUrl('img/MainFooter/payment-icons-per.png');
    case 'co':
      return getStaticUrl('img/MainFooter/payment-icons-col.png');
    case 'mx':
      return getStaticUrl('img/MainFooter/payment-icons-mex.png');
    default:
      return getStaticUrl('img/MainFooter/payment-icons.png');
  }
};

export const CREATIVE_CLOUD = [
  { label: 'Illustrator', link: '/cursos-online-adobe-illustrator/' },
  { label: 'Animate CC', link: '/cursos-online-adobe-animate-cc/' },
  { label: 'Photoshop', link: '/cursos-online-adobe-photoshop/' },
  { label: 'Audition', link: '/cursos-online-adobe-audition/' },
  { label: 'Premiere', link: '/cursos-online-adobe-premiere/' },
  { label: 'After Effects', link: '/cursos-online-after-effects/' },
  { label: 'InDesign', link: '/cursos-online-indesign/' },
  { label: 'Lightroom', link: '/cursos-online-adobe-photoshop-lightroom/' },
];

export const COMMUNITY = t => [
  {
    label: t('CREHANA_BUSINESS', {
      defaultValue: localesEs.es.translation.CREHANA_BUSINESS,
    }),
    link: '/empresas/',
    noCountryPrefix: true,
  },
  {
    label: t('COMMUNITY_SCHOLARSHIPS', {
      defaultValue: localesEs.es.translation.COMMUNITY_SCHOLARSHIPS,
    }),
    link: '/becas/',
    noCountryPrefix: true,
  },
  {
    label: t('COMMUNITY_STORIES', {
      defaultValue: localesEs.es.translation.COMMUNITY_STORIES,
    }),
    link: '/historias/',
    noCountryPrefix: true,
  },
  {
    label: t('COMMUNITY_PROJECTS', {
      defaultValue: localesEs.es.translation.COMMUNITY_PROJECTS,
    }),
    link: '/proyectos/',
    noCountryPrefix: true,
  },
  {
    label: t('COMMUNITY_RESOURCES', {
      defaultValue: localesEs.es.translation.COMMUNITY_RESOURCES,
    }),
    link: '/recursos/herramientas/',
    noCountryPrefix: true,
  },
  {
    label: t('COMMUNITY_BLOG', {
      defaultValue: localesEs.es.translation.COMMUNITY_BLOG,
    }),
    link: '/blog/',
  },
  {
    label: t('REMOTE_WORK', {
      defaultValue: localesEs.es.translation.REMOTE_WORK,
    }),
    link: '/trabajo-remoto/',
    noCountryPrefix: true,
  },
  // { label: 'Lives', link: '/lives/' },
  // { label: 'Enseña', link: '/ensena/' },
  // { label: 'Afiliados', link: '/afiliado/' },
  // { label: 'Membresías', link: '/membresias/' },
  // { label: 'Beneficios', link: '/beneficios/' },
  // { label: 'Verifica tu diploma', link: '/diplomas/' },
  // { label: 'Top Freebies', link: '/top-freebies/' },
];

export const US = (t, countryPrefix) => {
  const links = [
    {
      label: t('FOOTER_HIRING', {
        defaultValue: localesEs.es.translation.FOOTER_HIRING,
      }),
      link: '/trabaja-con-nosotros/',
      noCountryPrefix: true,
    },
    {
      label: t('FOOTER_ABOUT', {
        defaultValue: localesEs.es.translation.FOOTER_ABOUT,
      }),
      link: '/sobre-nosotros/',
      noCountryPrefix: true,
    },
    {
      label: t('FOOTER_TERMS', {
        defaultValue: localesEs.es.translation.FOOTER_TERMS,
      }),
      link: '/legal/terminos-y-condiciones/',
      noCountryPrefix: true,
    },
    {
      label:
        countryPrefix === 'mx'
          ? 'Avisos de privacidad'
          : t('FOOTER_PRIVACY', {
              defaultValue: localesEs.es.translation.FOOTER_PRIVACY,
            }),
      link:
        countryPrefix === 'mx'
          ? '/legal/avisos-de-privacidad/mx/'
          : '/legal/politicas-de-privacidad/',
      noCountryPrefix: true,
    },
    {
      label: t('FOOTER_COOKIES', {
        defaultValue: localesEs.es.translation.FOOTER_COOKIES,
      }),
      link: '/legal/politica-de-cookies/',
      noCountryPrefix: true,
    },
    {
      label: 'Solicitud ARCO',
      link: '/legal/solicitud-arco/',
      noCountryPrefix: true,
    },
    // { label: 'Acuerdos con los profesores', link: '/legal/acuerdo-para-profesores/' },
  ];

  if (countryPrefix === 'mx') {
    links.push({
      label: 'Política de cancelación',
      link: '/politica-cancelacion-mexico/',
      noCountryPrefix: true,
    });
  }

  if (countryPrefix === 'pe') {
    links.push({
      label: 'Libro de reclamaciones',
      link: '/libro-reclamaciones/',
      noCountryPrefix: true,
    });
  }

  return links;
};

export const CAREERS = [
  {
    label: 'Carrera de Ilustración',
    link: '/carreras/carrera-de-ilustracion/',
  },
  {
    label: 'Carrera de Modelado 3D',
    link: '/carreras/carrera-de-modelado-3d/',
  },
  {
    label: 'Carrera de Animación 2D',
    link: '/carreras/carrera-de-animacion-2d/',
  },
  {
    label: 'Carrera de Diseño Gráfico',
    link: '/carreras/carrera-de-diseno-grafico/',
  },
  {
    label: 'Mentores',
    link: '/mentores',
  },
];
